import React from 'react';
import { chunkArray } from '../../utils';
import '../callout_card.scss';
import { getCardId, CapabilityCardItem } from './cardHelpers';

const mdSlides = (slides, isPortalLivePreview = false, enableB2CRadius = false) => slides?.map((group, groupKey) => {
  const rowsPerSlide = chunkArray(group, 2);

  return (
    <div className="sui-flex sui-w-full sui-gap-y-6 sui-flex-col" key={groupKey}>
      {rowsPerSlide?.map((row, rowKey) => {
        return (
          <div className="sui-grid sui-grid-cols-2 sui-grid-rows-1 sui-gap-x-6" key={rowKey}>
            {row?.map((card, cardKey) => {
              const cardId = getCardId(card, cardKey);

              return (
                <div className="row_card" key={cardKey + cardId}>
                  <CapabilityCardItem
                    card={card}
                    cardId={cardId}
                    cardKey={cardKey}
                    isPortalLivePreview={isPortalLivePreview}
                    enableB2CRadius={enableB2CRadius}
                  />
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
});

export default mdSlides;
